import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { List, ListItem, Button } from '@material-ui/core';
import PrintIcon from '@material-ui/icons/Print';
import './Home.css';

function HomePage() {
    /** Vars for caching data, might be overkill but I like the idea, especially if we can work it into the app frameowrk */
    const CACHED_NAME = 'committees';
    const CACHED_SCHEMA = [
        {
          "id": 0,
          "name": "string",
          "term": "string",
          "appointments": "string",
          "meetingSchedule": "string",
          "meetingLocation": "string",
          "website": "string"
        }
      ];
    //useful for testing
    //localStorage.removeItem(CACHED_NAME);
    const CACHED_ITEM = JSON.parse(localStorage.getItem(CACHED_NAME)) || CACHED_SCHEMA;

    const [committees, setCommittees] = useState(CACHED_ITEM);

    useEffect(() => {
        fetch('https://api2.auburnalabama.org/committee/all', { credentials: 'include' })
            .then((response) => { if (response.ok) return response.json(); throw new Error('https://api2.auburnalabama.org/committee/all'); })
            .then((committees) => {
                committees.sort((a, b) => { return b.name < a.name ? 1 : -1 });
                setCommittees(committees);
                localStorage.setItem(CACHED_NAME, JSON.stringify(committees));
            })
            .catch(error => console.error(error));
    }, []); //run on initial load
    
    return (
        <section id="homePage">
            <header>
                <h2>Home</h2>
            </header>
            <main>
                <section>
                    <header className="withActions">
                        <h3>Boards and Commissions <small>list</small></h3>
                        <div>
                            <Button variant="contained" size="small" component={Link} to="print">
                                <PrintIcon></PrintIcon> Printable
                            </Button>
                        </div>
                    </header>
                    <List component="nav">
                        {committees.map((committee) => {
                            return <ListItem key={committee.id} component={Link} tabIndex="0"
                                    to={`committee/${committee.id}`}>{committee.name}</ListItem>
                        })}
                    </List>
                </section>
            </main>
        </section>
    );
}

export { HomePage };
